import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { RouteGuardService } from './service/route-guard.service';
import { View } from '../layout/model/interfaces/view.interface';

@Injectable({ providedIn: 'root' })
export class UsersProfileViewGuard implements CanActivate {
  private routeGuardService = inject(RouteGuardService);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const view = this.getView(route);
    if (view) {
      const shouldNavigate = await this.routeGuardService.handleRoute(view);
      return shouldNavigate;
    }
    return true;
  }

  getView(route?: ActivatedRouteSnapshot): View {
    const uuid = route?.paramMap?.get('uuid') || 'unknown';
    return {
      route: `users/${uuid}`,
      iframeUrl: `user/${uuid}`,
    };
  }
}
